export default __webpack_public_path__ + "static/img5-b4c1fff09018c52b81bfca46c0b375bd.png";